import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { CIVIL_STATUSES, CIVIL_STATUS_LABELS } from '../../../constants/civil-status';
import CONTRACT_INPUT_LABEL_PROPS from './contractInputLabelProps';

const CivilStatusInput = ({ input, obj, handleInfoFunc }) => (
  <TextField
    select
    sx={input.sx}
    id={input.id}
    label={input.label}
    value={obj[input.id] || ''}
    onChange={(e) => handleInfoFunc('civilStatus', e.target.value, obj.id)}
    SelectProps={{ className: input.selectClassName }}
    InputLabelProps={CONTRACT_INPUT_LABEL_PROPS}
  >
    {Object.values(CIVIL_STATUSES).map((status) => (
      <MenuItem key={status} value={status}>
        {CIVIL_STATUS_LABELS[status]}
      </MenuItem>
    ))}
  </TextField>
);

CivilStatusInput.propTypes = {
  input: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    selectClassName: PropTypes.string,
    sx: PropTypes.shape({
      width: PropTypes.string,
    }),
    inputProps: PropTypes.shape({
      style: PropTypes.shape({
        textTransform: PropTypes.string,
      }),
    }),
  }).isRequired,
  obj: PropTypes.shape({
    id: PropTypes.number,
    rut: PropTypes.string,
    mainDisabled: PropTypes.bool,
  }).isRequired,
  handleInfoFunc: PropTypes.func.isRequired,
};

export default CivilStatusInput;
